// extracted by mini-css-extract-plugin
export default {"btns_wrapper":"AuthBtns_btns_wrapper__pIZsl","login":"AuthBtns_login__Wkd3X","reg":"AuthBtns_reg__F7BLE"};